<template>
  <div class="stock-trend-query-view">
    <StockTrendQuery />
  </div>
</template>

<script>
import StockTrendQuery from '@/components/screening/StockTrendQuery.vue'

export default {
  name: 'StockTrendQueryView',
  components: {
    StockTrendQuery
  }
}
</script>

<style scoped>
.stock-trend-query-view {
  padding: 20px;
  flex: 1;
}
</style>
